import React from 'react';

export function CourseGoalsIntegrated({courseGoals}) {


    return (

        <div className={" border border-dark mb-5 p-4"}>

            <p className={"mb-3 fw-bold"}>Kompetansemål for kapittel</p>
            <ol>

                {
                    courseGoals.map(item => (
                        <li className={" px-3"}>
                            <p>{item.goal}</p>
                        </li>
                    ))
                }
            </ol>
        </div>


    );

}